export const allPlatforms = ["woocommerce", "magento", "magento2", "shopify", "prestashop"] as const
export type TPlatformValue = (typeof allPlatforms)[number]

export interface WebshopDetails {
    webshopId: string
    hostName: string
    alternativeHostName?: string
    clientId: string
    mcc: string
    platform: TPlatformValue
    isDisabled: boolean
    created: string
}
export interface IWebshopDetails {
    webshopLogoUrl?: string
    webshopLogoName?: string

    analyticsProvider?: TAnalyticsProvider

    plNotificationCustomizations?: IPaymentLinkNotificationCustomizations
}

type TAnalyticsProvider = "GoogleAnalytics"

export interface IPaymentLinkNotificationCustomizations {
    [lang: string]: {
        customHeader?: string
        customBody?: string
        signedBy?: string
    }
}
